<template lang="pug">
	.v-footer.footer(v-if="footer")
		.footer__container.container
			.footer__wrapper
				.footer__title
					.footer__title-main(v-if="footer.title") {{footer.title}}
					.footer__title-text(v-if="footer.text") {{footer.text}}
				.footer__contacts(v-if="isLoaded")
					template(v-if="$slots['contacts']")
						slot(name="contacts")
					template(v-if="$slots['map']")
						slot(name="map")
					.footer__chats-and-media
						template(v-if="$slots['chat']")
							slot(name="chat")
						template(v-if="$slots['media']")
							slot(name="media")
				.footer__footer
					.footer__footer-left
						template(v-for="(link, linkIndex) in footer.links" :key="linkIndex")
							a.footer__footer-link(:href="link.link")
								.footer__footer-text {{link.text}}
					.footer__footer-right(v-if="footer.linkButton")
						a.footer__developer-btn.btn(href="https://www.newsite.by/"
							target="_blank")
							| {{footer.linkButton.text}}
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import loadMixin from './mixins/v-load-mixin.vue';

export default {
	mixins: [
		sourceMixin,
		loadMixin
	],

	data() {
		return {
			footer: null
		};
	},

	methods: {
		dataSet(data) {
			this.footer = data;
		}
	}
};
</script>